import { Injectable } from '@angular/core';
import { DateRangeInterval } from '@app/core/components/date-range/date-range.component';
import { ErrorMessageResponse } from '@app/core/models/data-response';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class ShopFloorService {
    constructor(private datatask: DataTaskService) {}

    /**
     * Retrieves page get for shop floor.
     *
     * @datatask 3680
     * @datataskName sp_ws_p2_w_shopfloor_get
     * @param params for retrieving shop floor.
     * @returns promise containing page get for shop floor.
     */
    public async getShopFloor(params: GetShopFloorParams) {
        return (await this.datatask.Post(3680, params))[0];
    }

    /**
     * Retrieves info related to the selected job.
     *
     * @datatask 3685
     * @datataskName sp_ws_p2_w_shopfloor_selected_job_get
     * @param params for retrieving selected job.
     * @returns promise containing info relating to the selected job.
     */
    public async getShopFloorSelectedJob(params: ShopFloorGet): Promise<ShopFloorSelectedJobGet> {
        return (await this.datatask.Post(3685, params))[0];
    }

    /**
     * Starts the selected shopfloor job for the given shopflor settings.
     *
     * @datatask 3686
     * @datataskName sp_ws_p2_w_shopfloor_start_selected_job.
     * @param params the shopfloor and job to start.
     * @returns promise containing errorcode and errormessage.
     */
    public async startShopFloorSelectedJob(params: ShopFloorGet & Partial<ShopFloorSelectedJobGet>): Promise<StartShopFloorSelectedJobResponse> {
        return (await this.datatask.Post(3686, params))[0];
    }
}

export interface StartShopFloorSelectedJobResponse extends ErrorMessageResponse {
    goto_item_state: string;
    goto_item_parms: string;
}

export interface GetShopFloorParams {
    argtype: string;
    argvalue: string;
    comp_is_prod_id: string;
}

export interface ShopFloorGet {
    businessco_no: string;
    factory_id: string;
    operation_id: string;
    equipment_id: string;
    date_fom: string;
    date_tom: string;
    dateselector_index: DateRangeInterval;
    date_fomtom: string;
    selected_jobid: string | number;
    selected_jobtype: string;
    labour_no: string;
    labour_name: string;
    gb_shopfloor_main: string;
    argtype: string;
    argvalue: string;
    webpage_heading: string;
    order_internal_no: string;
    show_setting: '1' | '0';
    comp_prod_id: string;
    comp_prod_name: string;
}

export interface ShopFloorSelectedJobGet {
    prod_id: string;
    prod_name: string;
    url_picture: string;
    show_button_start_selected_job: '1' | '0';
    stamped: '1' | '0';
    order_order_no: string;
    stat_cust_no: string;
    stat_cust_name: string;
}
